import { OperationVariables, QueryHookOptions, useQuery } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { Page } from '../../types/graphql';

import { usePathInfo } from '../hooks/usePathInfo';
import { resolvePageQueryParams } from '../utils/typeSlugManipulator';

export type WithoutPageQueryVariables<T> = Omit<T, 'slug' | 'type'>;
type WithPageQueryVariables<T> = T & Pick<Page, 'type' | 'slug'>;

export const usePageQuery = <TData = any, TVariables = OperationVariables>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, WithoutPageQueryVariables<TVariables>>
) => {
  const { pageSlug: slug, pageType: type } = usePathInfo();
  const { resolvedType, resolvedSlug } = resolvePageQueryParams(type, slug);
  const { fetchMore, ...useQueryResult } = useQuery<
    TData,
    WithoutPageQueryVariables<TVariables>
  >(query, {
    ...options,
    variables: {
      ...options?.variables,
      slug: resolvedSlug,
      type: resolvedType,
    } as WithPageQueryVariables<TVariables>,
    skip: !resolvedSlug,
  });

  const pageQueryFetchMore = (
    variables: WithoutPageQueryVariables<TVariables>
  ) => {
    fetchMore({
      variables: {
        ...variables,
        slug: resolvedSlug,
        type: resolvedType,
      },
    });
  };
  return { fetchMore: pageQueryFetchMore, ...useQueryResult };
};
